const menuToggle = document.querySelector('#menu-toggle');
// const header = document.querySelector('#header');
// const body = document.querySelector('body');
// const navigationMobile = document.querySelector('#navbarSupportedContent');

const activateToggle = () => {
  menuToggle.addEventListener('click', () => {
    // navigationMobile.classList.toggle('visible');
    // header.classList.toggle('visible');
    // body.classList.toggle('visible');
    menuToggle.classList.toggle('active');
    menuToggle.classList.toggle('not-active');
  });
};

export default activateToggle;
